import { colors } from '@common/helpers';
import { TooltipVariants } from '../constants';
import { DateRangeOptionId } from '../../DateRangeDropdown';
import { CSSProperties } from 'react';

export interface SingleValueBarFormat {
  recollect?: number;
  value: number;
  groupValue: string;
}

export const isSingleValueBarFormat = (data: any): data is SingleValueBarFormat => {
  if (!data.groupValue && !data.value) {
    return false;
  }
  return true;
};

export const isSingleValueBarFormatArray = (data: any): data is SingleValueBarFormat[] => {
  if (Array.isArray(data)) {
    return data.every(isSingleValueBarFormat);
  }
  return false;
};

export interface StackedBarFormatData {
  [key: string]: number;
}

export interface StackedBarFormat {
  name: string;
  data: StackedBarFormatData;
}

export const isStackedBarFormat = (data: any): data is StackedBarFormat => {
  if (!data.data) {
    return false;
  }
  return true;
};

export const isStackedBarFormatArray = (data: any): data is StackedBarFormat[] => {
  if (Array.isArray(data)) {
    return data.every(isStackedBarFormat);
  }
  return false;
};

export interface StackedBarFormatColors {
  id: string;
  name: string;
  color: string;
}

export interface BarChartProps {
  baseline?: number | null;
  baselinePeriod?: DateRangeOptionId;
  chartProps?: ChartProps;
  colors?: BarChartColor;
  data: SingleValueBarFormat[] | StackedBarFormat[];
  stackedColors?: StackedBarFormatColors[];
  minData?: number;
  startAtEnd?: boolean;
  tickY?: TickY;
  tickX?: TickX;
  tooltip?: string;
  tooltipVariant?: TooltipVariants;
  xAxisKey?: string;
  dataKey?: string;
  stackedBarChart?: {
    tooltipEndValue?: string;
    tooltipBackgroundColor?: string;
  };
}

export interface ChartProps {
  minHeight?: number | string;
  minWidth?: number | string;
}

export interface TickX {
  // This fn is meant to transform the
  // tick names in a specific way instead
  // of keep adding cases to the chart
  // each value in the array will be added after
  // and blank line in a vertical way
  transformLabelFn?: (tickName: string) => string[];
  // This fn is meant to add styles to the tick names
  // the index is the first word of a tick that has been divide
  transformLabelCssFn?: (idx: number) => CSSProperties;
}

export interface TickY {
  max?: number | string;
  min?: number | string;
  scale?: number;
  unit: TickUnit;
}

export interface TickUnit {
  onlyOnMin?: boolean;
  onlyOnMax?: boolean;
  symbol?: string;
}

/**  BarChartColor prop should be used with colors from @common/helpers  */
export interface BarChartColor {
  bar?: string;
  baseline?: string;
  grid?: string;
  labelX?: string;
  labelY?: string;
}

export const BAR_COLOR_DEFAULT = colors.darkBlue300;
export const BASELINE_COLOR_DEFAULT = colors.teal300;
export const GRID_COLOR_DEFAULT = colors.coolGray200;
export const LABEL_X_COLOR_DEFAULT = colors.darkGray200;
export const LABEL_Y_COLOR_DEFAULT = colors.darkGray200;
export const MIN_BRUSH_DEFAULT_LENGTH = 12;
